export default __webpack_public_path__ + "static/media/pic41.83fb7dcd.jpg";